module.exports = __webpack_public_path__ + "img/anp.a2875a14.png";